"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledControlButtonClose = exports.StyledTitle = exports.StyledModalControlDefault = void 0;

const styled_components_1 = __importStar(require("styled-components"));

const styles_1 = require("../styles");

exports.StyledModalControlDefault = styled_components_1.default.div`
  position: fixed;
  width: ${props => props.width || 'auto'};
  height: ${props => props.height || 'auto'};
  background-color: ${props => props.backgroundColor || props.theme.colors.white};
  box-shadow: 0 3px 6px #00000029;
  box-sizing: content-box;
  border-radius: 4px;
  border: 1px solid ${props => props.theme.colors.gray_302};
  z-index: 10001;

  ${props => {
  if (props.position === 'top') {
    var _props$parentRef;

    // eslint-disable-next-line
    const parent = (_props$parentRef = props.parentRef) === null || _props$parentRef === void 0 ? void 0 : _props$parentRef.current;
    const diffTop = 20 + 2 * parseInt((parent === null || parent === void 0 ? void 0 : parent.offsetHeight) || '0px') + parseInt(props.height || '0px');
    const slide = (0, styled_components_1.keyframes)`
        from {
          //transform: translateY(100%);
          opacity: 0;
        }
        to {
          //transform: translateY(0);
          opacity: 1;
        }
      `;
    return (0, styled_components_1.css)`
        margin-left: 35px;
        margin-top: -${diffTop}px;
        animation: 0.2s ease-in;
        animation-name: ${slide};
      `;
  } else if (props.position === 'bottom') {
    const slide = (0, styled_components_1.keyframes)`
        from {
          //transform: translateY(-100%);
          opacity: 0;
        }
      
        to {
          //transform: translateY(0);
          opacity: 1;
        }
      `;
    return (0, styled_components_1.css)`
        margin-left: 35px;
        margin-top: 40px;
        animation: 0.2s ease-in;
        animation-name: ${slide};
      `;
  } else if (props.position === 'left') {
    var _props$parentRef2;

    // eslint-disable-next-line
    const parent = (_props$parentRef2 = props.parentRef) === null || _props$parentRef2 === void 0 ? void 0 : _props$parentRef2.current;
    const diffLeft = 35 + parseInt(props.width || '0px');
    const diffTop = 6 + 2 * parseInt((parent === null || parent === void 0 ? void 0 : parent.offsetHeight) || '0px');
    const slide = (0, styled_components_1.keyframes)`
        from {
          //transform: translateX(100%);
          opacity: 0;
        }
      
        to {
          //transform: translateX(0);
          opacity: 1;
        }
      `;
    return (0, styled_components_1.css)`
        margin-left: -${diffLeft}px;
        margin-top: -${diffTop}px;
        animation: 0.2s ease-in;
        animation-name: ${slide};
      `;
  } else {
    var _props$parentRef3;

    // eslint-disable-next-line
    const parent = (_props$parentRef3 = props.parentRef) === null || _props$parentRef3 === void 0 ? void 0 : _props$parentRef3.current;
    const diffLeft = 35 + parseInt((parent === null || parent === void 0 ? void 0 : parent.offsetWidth) || '0px');
    const diffTop = 6 + 2 * parseInt((parent === null || parent === void 0 ? void 0 : parent.offsetHeight) || '0px');
    const slide = (0, styled_components_1.keyframes)`
        from {
          //transform: translateX(-100%);
          opacity: 0;
        }
      
        to {
          //transform: translateX(0);
          opacity: 1;
        }
      `;
    return (0, styled_components_1.css)`
        margin-left: ${diffLeft}px;
        margin-top: -${diffTop}px;
        animation: 0.2s ease-in;
        animation-name: ${slide};
      `;
  }
}}
`;
exports.StyledTitle = styled_components_1.default.div`
  color: ${props => props.theme.colors.gray_602};
  opacity: 0.9;
  font-family: Roboto, sans-serif;
  font-weight: bold;
  font-size: ${props => props.theme.fontSizes[14]};
  margin-bottom: 7px;
  height: 16px;
  line-height: 16px;
`;
exports.StyledControlButtonClose = (0, styled_components_1.default)(styles_1.StyledButtonClose)`
  right: 15px;
  top: 10px;
`;